//styles
import {
  FeaturesWrapper,
  FeaturedListWrapper,
  HeaderSection,
  Title,
  Description,
} from './OfferList.styles';

//containers
import { ContentPill } from '@/components/ContentPill';
import { Container } from '@/components/Grid';

export default function OfferList() {
  const featuredListContent = [
    {
      icon: null,
      title: 'Loadsmart Platform',
      description:
        'One connected platform that runs your complete freight lifecycle. ShipperGuide for transportation management. Opendock for dock, gate, and yard. They share one data set. AI agents handle the repetitive work, Freight Experts resolve the exceptions, and outcomes are delivered back to your system of record. Nothing to rip out, nothing to migrate.',
      link: {
        url: '/',
        label: 'Learn More',
      },
    },
    {
      icon: null,
      title: 'Loadsmart AI',
      description:
        'Six specialized agents that run freight tasks end to end: document collection and filing, tracking, retendering, load audits, claims, and scheduling. They operate continuously under the rules you set, auto-resolving 80%+ of the work. That rate compounds over time. The 20% that needs human judgment goes to Freight Experts. You get 100% of outcomes delivered.',
      link: {
        url: '/ai/',
        label: 'Learn More',
      },
    },
    {
      icon: null,
      title: 'Dock, Gate, and Yard',
      description:
        'Opendock digitizes how freight enters, moves through, and exits your facilities. Carrier self-service scheduling, gate automation, and yard management across 4,500+ warehouses and 230,000+ carriers. When a pickup slips, the scheduling agent reschedules and notifies all parties automatically.',
      link: {
        url: 'https://opendock.com',
        label: 'Learn More',
      },
    },
    {
      icon: null,
      title: 'AI-native TMS',
      description:
        'ShipperGuide plans, procures, executes, and settles freight across all modes. AI is built into the foundation, not bolted on. Agents run tendering, tracking, documents, auditing, and claims inside the TMS. Your role shifts from operating the system to supervising it.',
      link: {
        url: 'https://shipperguide.com',
        label: 'Learn More',
      },
    },
    {
      icon: null,
      title: 'Freight Brokerage',
      description:
        'Technology-enabled freight brokerage backed by 100,000+ vetted carriers. Runs on the same platform and the same intelligence as every other Loadsmart service. Your routing guide and carrier preferences govern execution. Brokerage is available when you want it, never imposed by the platform.',
      link: {
        url: '/shipper/',
        label: 'Learn More',
      },
    },
    {
      icon: null,
      title: 'Managed Transportation',
      description:
        'End-to-end transportation management as a service, powered by the Loadsmart Platform. Acts as an extension of your team with dedicated specialists and forward-deployed engineers. AI runs the repetitive work. Freight Experts handle the exceptions. You supervise the results.',
      link: {
        url: '/shipper/managed-transportation/',
        label: 'Learn More',
      },
    },
  ];

  return (
    <FeaturesWrapper>
      <Container>
        <HeaderSection>
          <Title>What we offer</Title>
          <Description>
            Loadsmart is transforming the logistics landscape by leveraging
            cutting-edge technology and industry expertise to deliver optimized,
            reliable, and transparent freight services and solutions. From
            digital freight brokerage and consultancy to software tools, we
            empower shippers, carriers, and warehouses to move more with
            less—increasing efficiency, reducing costs, and enhancing service
            quality.
          </Description>
        </HeaderSection>
        <FeaturedListWrapper>
          {featuredListContent.length > 0 &&
            featuredListContent.map((item, key) => {
              return (
                <ContentPill
                  key={`itemlist-` + key}
                  content={item}
                  className="green"
                />
              );
            })}
        </FeaturedListWrapper>
      </Container>
    </FeaturesWrapper>
  );
}

export { OfferList };
